import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  container: css`
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 9999;
    display: flex;
    flex-direction: column-reverse;
    gap: 16px;
    pointer-events: none;
  `,
  toastWrapper: css`
    pointer-events: auto;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
